import { I18n } from "@assets/strings";
import React from "react";
import { useReactionProfiles } from "@domain/post/hooks";
import { PostReactionType } from "@domain/post/post";
import { ProfileListModal } from "@ui/components/profile/profileListModal";

interface ReactionsModalProps extends React.HTMLAttributes<HTMLDivElement> {
	postId: string;
	reaction: PostReactionType;
	close: () => void;
	commentId?: string;
}
export const ReactionsModal: React.FC<ReactionsModalProps> = ({ postId, commentId, reaction, ...props }) => {
	const data = useReactionProfiles(postId, reaction, commentId);

	return (
		<ProfileListModal
			title={I18n.t(`post.${reaction}.title`)}
			emptyMessage={I18n.t(`post.${reaction}.empty`)}
			data={data}
			{...props}
		/>
	);
};
